<template>
  <v-os-popup
    ref="partListPopup"
    class="part-list-popup"
    v-model="isShow"
    title="原装配件"
    :closeShow="true"
    :footerShow="false"
    @close="close"
    container="body"
  >
    <template v-if="list && list.length">
      <p class="popup-title">{{ modelName }}原装配件</p>
      <ol class="part-list">
        <li
          v-for="(skuInfo, idx) of list"
          :key="idx"
          class="part-item"
          role="link"
          tabindex="0"
          @click="gotoDetail(skuInfo)"
        >
          <p class="pic border1px">
            <img v-lazy="skuInfo.image" aria-hidden="true" />
          </p>
          <div class="part-content">
            <p class="name lc-1">{{ skuInfo.skuName }}</p>
            <p class="info lc-2">{{ skuInfo.brief }}</p>
            <p class="price">
              ￥{{ skuInfo.salePrice }}
              <span
                class="cost tx-lt"
                v-if="parseFloat(skuInfo.marketPrice) > parseFloat(skuInfo.salePrice)"
                :aria-label="`原价￥${skuInfo.marketPrice}`"
              >
                ￥{{ skuInfo.marketPrice }}
              </span>
            </p>
          </div>
          <div class="buy-btn">立即购买</div>
        </li>
      </ol>
    </template>
    <div v-else class="no-part">
      <img src="./img/part-default.png" />
      <p class="no-part-tip">当前暂无可购买的原装配件</p>
    </div>
  </v-os-popup>
</template>
<script>
import app from 'utils/app'
export default {
  name: 'PartListPopup',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default() {
        return []
      }
    },
    modelName: {
      type: String,
      default: ''
    }
  },
  watch: {
    isShow(val) {
      if (val) {
        this.$track({
          cfrom: '081|073|02|077',
          event_id: '081|073|02|077'
        })
        setTimeout(() => {
          this.$refs.partListPopup?.focusEl('title')
        }, 100)
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    // 跳转详情页
    gotoDetail(product) {
      this.$track({
        cfrom: '081|073|01|077',
        event_id: '081|073|01|077'
      })
      app.openNewWebview({
        url: product.jumpUrl || `${this.linkBase}/product/${product.spuId}?skuId=${product.skuId}`
      })
    }
  }
}
</script>
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>
<style lang="scss" scoped>
.popup-title {
  font-size: 42px;
  line-height: 42px;
  @include fontColor(#000, rgba(255, 255, 255, 0.84));
  @include os-font-weight(42, 40);
  margin-top: 42px;
  margin-bottom: 60px;
  box-sizing: border-box;
}
.part-list {
  box-sizing: border-box;
}
.no-part {
  text-align: center;
  img {
    margin-top: 103px;
    width: 324px;
    height: 324px;
  }
}
.no-part-tip {
  margin-top: 14px;
  font-size: 42px;
  line-height: 54px;
  color: #b4b4b4;
}
.part-item {
  display: flex;
  align-items: center;
  margin-bottom: 48px;
  cursor: pointer;

  .pic {
    width: 240px;
    height: 240px;
    flex-shrink: 0;
    overflow: hidden;
    &.border1px {
      @include border1px(1111, rgba(221, 221, 221, 0.6), 24px);
      @media (prefers-color-scheme: dark) {
        border-color: rgba(255, 255, 255, 0.15);
      }
    }
    img {
      width: 100%;
      height: auto;
    }
  }
  .part-content {
    flex: 1;
    padding: 0 77px 0 39px;
  }
  .name {
    font-size: 42px;
    line-height: 60px;
    @include fontColor(#000, rgba(255, 255, 255, 0.84));
    @include os-font-weight(42, 40);
  }
  .info {
    font-size: 33px;
    line-height: 42px;
    color: #888888;
  }
  .price {
    color: #f10313;
    font-size: 42px;
    line-height: 42px;
    margin-top: 21px;
    .cost {
      color: #bbb;
      font-size: 36px;
    }
  }
  .buy-btn {
    border: none;
    flex-shrink: 0;
    padding: 0 18px;
    height: 60px;
    background: linear-gradient(90deg, #e51422 0%, #ff0c53 100%);
    border-radius: 104px;
    font-size: 30px;
    line-height: 60px;
    text-align: center;
    @include fontColor(#ffffff, rgba(255, 255, 255, 0.9));
    @include flex-inline-center;
  }
}
</style>
